import React from 'react';
import CyclingLoader from './CyclingLoader';
import InlineSpinner from './InlineSpinner';
import type { SpinnerRingSize } from './SpinnerRing';

type TableLoadingOverlayProps = {
  loading: boolean;
  label?: string;
  /** When set, cycles through these messages (Slack-style). Falls back to `label`. */
  loadingPhrases?: string[];
  children: React.ReactNode;
  className?: string;
  /** Spinner size for the overlay; `md` (default) fits a full table/pane, `sm` a smaller panel. */
  size?: SpinnerRingSize;
  /** Bare spinner, no label — for panels too short to fit CyclingLoader's spinner+text stack. */
  compact?: boolean;
};

export default function TableLoadingOverlay(props: TableLoadingOverlayProps): React.ReactElement {
  const { loading, label = 'Refreshing…', loadingPhrases, children, className = '', size = 'md', compact = false } = props;
  const phrases = loadingPhrases?.length ? loadingPhrases : [label];

  return (
    <div className={`relative ${className}`}>
      <div className={`h-full min-h-0 ${loading ? 'pointer-events-none blur-[1px]' : ''}`}>{children}</div>
      {loading ? (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/85 dark:bg-slate-900/85 backdrop-blur-sm pointer-events-none">
          {compact ? (
            <InlineSpinner size={size} variant="accent" />
          ) : (
            <CyclingLoader phrases={phrases} size={size} />
          )}
        </div>
      ) : null}
    </div>
  );
}
